import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'videojs-landscape-fullscreen';
import './scss/main.scss';

ReactDOM.createRoot(document.querySelector('#root')).render(<App />);
